import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { formatDate } from '../../utils/dateUtils';

export default function UserList() {
  const { token, user } = useAuth();
  const [users, setUsers] = useState([]);

  const loggedinUser = user;

  useEffect(() => {
    if (!token) return;
    const fetchUsers = async () => {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(res.data);
    };
    fetchUsers();
  }, [token]);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;

    try {
            await axios.delete(`${process.env.REACT_APP_API_URL}/api/users/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        // Optionally refetch or locally update state
        setUsers((prevUsers) => prevUsers.filter(user => user._id !== id));
    } catch (err) {
        alert('Failed to delete user');
    }
  };

  return (
    <div className="container mt-4">
      <h2>User Management</h2>
      <Link to="/users/create" className="btn btn-primary mb-3">Create New User</Link>
      <table className="table table-bordered">
        <thead>
          <tr>
             <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Created at</th>
            <th>Last Update</th>
            { loggedinUser?.email !== "onkeok@pnpclaos.com" &&
              <th>Actions</th>
            }
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user._id}>
            <td>{++index}</td>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{formatDate(user.createdAt)}</td>
              <td>{formatDate(user.updatedAt)}</td>
              <td>
                <span className={
                    user.role === 'IT' ? 'badge bg-danger' :
                    user.role === 'Executive' ? 'badge bg-warning' :
                    'badge bg-info' // Default for Employee
                }>
                    {user.role}
                </span>
              </td>
              { loggedinUser?.email !== "onkeok@pnpclaos.com" &&
                <td>
                  <Link to={`/users/edit/${user._id}`} className="btn btn-sm btn-outline-secondary me-2">
                      Edit
                  </Link>
                  <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDelete(user._id)}
                  >
                      Delete
                  </button>
                </td>
              }
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
